// extracted by css-extract-rspack-plugin
export default {"MetadataSidebarContainer":"MetadataSidebar-module__MetadataSidebarContainer__V9I_bNE","CreateIssueAssigneesSection":"MetadataSidebar-module__CreateIssueAssigneesSection__R__MrD7"};